import { Link } from 'react-router-dom';
import { categories } from '@/mocks/navigation';

export default function Footer() {
  return (
    <footer style={{ backgroundColor: 'oklch(0.16 0.04 252)' }} className="text-background-50/90">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-compass-3-line text-background-50 text-lg"></i>
              </div>
              <span className="text-lg font-semibold font-heading text-background-50">
                蓝色导航发布页
              </span>
            </div>
            <p className="text-sm text-background-50/60 leading-relaxed">
              专业的内容发布与网站导航平台，让每一次发布都精准触达目标用户。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">导航分类</h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 4).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">更多分类</h4>
            <ul className="space-y-2.5">
              {categories.slice(4).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">关于我们</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/about" className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap">
                  品牌介绍
                </Link>
              </li>
              <li>
                <a href="mailto:contact@bluenav.com" className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap">
                  联系我们
                </a>
              </li>
              <li>
                <span className="text-sm text-background-50/60 whitespace-nowrap">服务热线: 400-888-6666</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-50/40 whitespace-nowrap">
            &copy; 2020-2026 蓝色导航发布页 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-sm text-background-50/40 hover:text-background-50/70 transition-colors whitespace-nowrap" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-sm text-background-50/40 hover:text-background-50/70 transition-colors whitespace-nowrap" rel="nofollow">
              服务条款
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}